module.exports = __webpack_public_path__ + "static/media/BizTechFrame3.73df87a0.png";